import React from 'react';
import './OptionsGroups.scss';
import { ReactComponent as AddGroup } from 'Icons/Sidebar/AddGroup.svg';
import { ReactComponent as RemoveGroup } from 'Icons/Sidebar/RemoveGroup.svg';
import { ReactComponent as IngredientsRect } from 'Icons/Sidebar/IngredientsRect.svg';
import { ReactComponent as Edit } from 'Icons/CommandPanel/Edit.svg';
import { ReactComponent as Delete } from 'Icons/CommandPanel/Delete.svg';
import { ReactComponent as ScreenRect } from 'Icons/Sidebar/Screen.svg';
import {
  ProteinCardProps,
  RandomLayerGroupIngredientProps,
  ScreenCardProps,
  StockCardProps,
  IngredientCardProps,
  SeedCardProps,
} from 'business/models/CustomModels';
import {
  getIngIdStockNumber,
  getIngredientColor,
  getIngredientTypeName,
  getIngredientName,
  getIngredientStock,
  isNullOrUndefined,
  getIngNameByIngId,
  getStockConcVendor,
  GetIngredients,
  getVaryAlongName,
  GetProteinFormulationName,
  GetSeedName,
  SetFavouriteStocks,
  showSnackBar,
} from 'utils/Global';
import ELayersView, { EGridVaryAlong } from 'enums/ELayersView';
import {
  FavouriteIngredientStockDTO,
  IngredientStockDTO,
  ProteinLayerProteinFormulationDTO,
  SeedLayerDetailsDTO,
} from 'business/models/Models';
import { FmlxButton } from 'fmlx-common-ui';
import { useIsScreenIngredientEditable } from 'redux/hooks/common';
import RMSvgIcon from '../CommonComponents/RMSvgIcon';
import { updateFavouriteIngStock } from 'business/services/IngredientService';
import RMCustomButton from '../CommonComponents/RMCustomButton/RMCustomButton';

type OptionsGroupsProps = {
  label1: string;
  label2: string;
  checkbox1?: boolean;
  checkbox2?: boolean;
  disabled?: boolean;
  vertical?: boolean;
  changeCheckbox1?: (e) => void;
  changeCheckbox2?: (e) => void;
};

type RadioGroupProps = {
  orientation?: 'Vertical' | 'Horizontal';
  label1: string;
  label2: string;
  radioValue?: boolean;
  onChange?: () => void;
  disabledFirst?: boolean;
  disabledSecond?: boolean;
  disabled?: boolean;
  style?: any;
};

export default function OptionsGroups({
  label1,
  label2,
  checkbox1,
  checkbox2 = false,
  changeCheckbox1,
  changeCheckbox2,
  disabled = false,
  vertical = false,
}: OptionsGroupsProps) {
  return (
    <div
      id="inputgroups-options-groups"
      data-testid="inputgroups-options-groups"
      style={{
        display: 'flex',
        flexDirection: vertical ? 'column' : 'row',
        gap: '0.5rem',
      }}
    >
      <LabelCheckbox
        labelText={label1}
        checkBoxValue={checkbox1}
        onChange={changeCheckbox1}
        disabled={disabled}
      />
      <LabelCheckbox
        labelText={label2}
        checkBoxValue={checkbox2}
        onChange={changeCheckbox2}
        disabled={disabled}
      />
    </div>
  );
}

export function LabelCheckbox({
  labelText,
  checkBoxValue,
  onChange,
  style = null,
  disabled = false,
}) {
  return (
    <div
      id="inputgroups-labelcheckbox-wrapper"
      data-testid="inputgroups-labelcheckbox-wrapper"
      className="flex flex-y-center input-container"
      style={style}
    >
      <input
        id="inputgroups-labelcheckbox-input-checkbox"
        data-testid="inputgroups-labelcheckbox-input-checkbox"
        className="layer-checkbox"
        type="checkbox"
        checked={checkBoxValue}
        onChange={onChange}
        disabled={disabled}
      />
      <label
        id={`inputgroups-label-checkbox-${labelText}`}
        data-testid={`inputgroups-label-checkbox-${labelText}`}
        className="layer-label"
      >
        {labelText}
      </label>
    </div>
  );
}

export function LabelRadioBox({
  labelText,
  radioValue,
  onChange,
  name,
  disabled = false,
  style = null,
}) {
  return (
    <div
      id="inputgroups-labelradiobox-wrapper"
      data-testid="inputgroups-labelradiobox-wrapper"
      style={{
        display: 'flex',
        gap: '0.5rem',
        ...style,
      }}
    >
      <input
        id={`inputgroups-labelradiobox-input-checkbox-${name}`}
        data-testid={`inputgroups-labelradiobox-input-checkbox-${name}`}
        className="layer-checkbox"
        type="radio"
        name={name}
        checked={radioValue}
        onChange={onChange}
        disabled={disabled}
        style={{
          margin: 0,
          verticalAlign: 'middle',
        }}
      />
      <label
        id={`inputgroups-label-radiobox-${labelText}`}
        data-testid={`inputgroups-label-radiobox-${labelText}`}
        style={{
          margin: 0,
          lineHeight: '1.2',
          verticalAlign: 'middle',
        }}
      >
        {labelText}
      </label>
    </div>
  );
}

export function OptionsGroupsVertical({ label1, label2 }) {
  return (
    <div id="inputgroups-options-groups-vertical" data-testid="inputgroups-options-groups-vertical" className="flex flex-column">
      <div
        id="inputgroups-options-groups-vertical-input1-container"
        data-testid="inputgroups-options-groups-vertical-input1-container"
        className="flex ml-40 flex-y-center input-container"
      >
        <input
          id="inputgroups-options-groups-vertical-layer1-checkbox"
          data-testid="inputgroups-options-groups-vertical-layer1-checkbox"
          className="layer-checkbox"
          type="checkbox"
        />
        <label
          id={`inputgroups-options-groups-vertical-layer1-${label1}`}
          data-testid={`inputgroups-options-groups-vertical-layer1-${label1}`}
          className="layer-label"
        >
          {label1}
        </label>
      </div>
      <div
        id="inputgroups-options-groups-vertical-input2-container"
        data-testid="inputgroups-options-groups-vertical-input2-container"
        className="flex ml-40 flex-y-center input-container"
      >
        <input
          id="inputgroups-options-groups-vertical-layer2-checkbox"
          data-testid="inputgroups-options-groups-vertical-layer2-checkbox"
          className="layer-checkbox"
          type="checkbox"
        />
        <label
          id={`inputgroups-options-groups-vertical-layer2-${label2}`}
          data-testid={`inputgroups-options-groups-vertical-layer2-${label2}`}
          className="layer-label"
        >
          {label2}
        </label>
      </div>
    </div>
  );
}

export function RadioGroups({
  orientation = 'Vertical',
  label1,
  label2,
  radioValue,
  onChange,
  disabledFirst = false,
  disabledSecond = false,
  disabled = false,
  style = null,
}: RadioGroupProps) {
  return (
    <div
      id="inputgroups-radio-groups"
      data-testid="inputgroups-radio-groups"
      style={{
        display: 'flex',
        flexDirection: orientation === 'Vertical' ? 'column' : 'row',
        alignItems: orientation === 'Vertical' ? 'flex-start' : 'center',
        gap: '1rem',
        ...style,
      }}
    >
      <LabelRadioBox
        labelText={label1}
        radioValue={radioValue}
        onChange={onChange}
        name="concentration"
        disabled={disabledFirst || disabled}
      />
      <LabelRadioBox
        labelText={label2}
        radioValue={!radioValue}
        onChange={onChange}
        name="volume"
        disabled={disabledSecond || disabled}
      />
    </div>
  );
}

export function IngredientItem({ text, onClick }) {
  return (
    <div
      id={`inputgroups-ingredient-item-${text}`}
      data-testid={`inputgroups-ingredient-item-${text}`}
      className="ingredient-item"
      onClick={onClick}
    >
      {text}
    </div>
  );
}

export function FavouriteIngredientStockCard({ ing, onClick, setGlobalFavIngStocks }) {
  return (
    <div
      id="inputgroups-favourite-ingredient-stock-card"
      data-testid="inputgroups-favourite-ingredient-stock-card"
      onClick={onClick}
      className="cursor-pointer w-[100%] border border-solid border-[#B4B4B4] rounded-[4px] justify-items-center content-center mb-[1.5%]"
    >
      <div
        id="inputgroups-favourite-ingredient-stock-card-flex-row"
        data-testid="inputgroups-favourite-ingredient-stock-card-flex-row"
        className="w-[96%] mt-[.08rem] mb-[.08rem] flex flex-row"
      >
        <div
          id="inputgroups-favourite-ingredient-stock-card-flex-col"
          data-testid="inputgroups-favourite-ingredient-stock-card-flex-col"
          className="w-[90%] flex flex-col"
        >
          <div
            id={`inputgroups-favourite-ingredient-stock-card-longname-${ing?.stock?.ingredientId || "default"}`}
            data-testid={`inputgroups-favourite-ingredient-stock-card-longname-${ing?.stock?.ingredientId || "default"}`}
            className="text-[#313131] text-[0.75rem] font-bold"
          >
            {ing?.ingredient?.longName}
          </div>
          <div
            id="inputgroups-favourite-ingredient-stock-card-conc-vendor"
            data-testid="inputgroups-favourite-ingredient-stock-card-conc-vendor"
            className="text-[#313131] text-[0.75rem] font-bold"
          >
            {getStockConcVendor(ing.stock, false)}
          </div>
          <div
            id="inputgroups-favourite-ingredient-stock-card-stock-number"
            data-testid="inputgroups-favourite-ingredient-stock-card-stock-number"
            className="text-[#5D5D5D] text-[0.75rem]"
          >
            {getIngIdStockNumber(ing.stock.ingredientId, ing.stock.stockNumber)}
          </div>
        </div>
        <div
          id="inputgroups-favourite-ingredient-stock-card-button"
          data-testid="inputgroups-favourite-ingredient-stock-card-button"
          className="w-[10%] justify-items-end"
        >
          <RMCustomButton
            onClick={(e) =>
              updateFavouriteStock(e, ing?.stock, true, setGlobalFavIngStocks)
            }
            isDisabled={false}
            iconProps={{
              name: 'Favourite',
              fill: '#FFCA0A',
              width: '1.5rem',
              height: '1.5rem',
            }}
            contentContainerStyle={{
              width: '1.5rem',
              height: '1.5rem',
            }}
            mainContainerClass="hover:shadow-lg hover:scale-125 transition-all"
          />
        </div>
      </div>
    </div>
  );
}

export function GroupItem({ text, onClick, isSelected, onDelete, probability }) {
  function getGroupDetail() {
    if (isNullOrUndefined(probability)) {
      return text;
    }
    return (
      <>
        <div
          id="inputgroups-group-items-group-detail"
          data-testid="inputgroups-group-items-group-detail"
          className="w-60"
        >
          {text}
        </div>
        <div
          id="inputgroups-group-items-group-detail-probability"
          data-testid="inputgroups-group-items-group-detail-probability"
          className="w-40 text-align-end"
        >
          Probability: {probability}
        </div>
      </>
    );
  }
  return (
    <div
      id=" inputgroups-group-items-selected"
      data-testid="inputgroups-group-items-selected"
      className={`group-item ${isSelected ? 'group-item-selected' : null}`}
      style={{ background: isSelected && text === '' ? '#EE543B' : null }}
      onClick={onClick}
    >
      <div
        id="inputgroups-group-items-group-detail"
        data-testid="inputgroups-group-items-group-detail-wrapper"
        className="w-85 overflow-auto flex"
        style={{ alignItems: 'center' }}
      >
        {getGroupDetail()}
      </div>
      <div
        id="inputgroups-group-items-delete-update-enabled"
        data-testid="inputgroups-group-items-delete-update-enabled"
        className="flex ing-delete-update-enabled flex-space-between w-15"
      >
        <Delete
          data-testid="inputgroups-group-items-delete-update-enabled-button"
          className="edit-group-svgs cursor-pointer"
          fill="black"
          onClick={onDelete}
        />
      </div>
    </div>
  );
}
export function NewGroupItem({
  text,
  onClickRemoveAddGroup,
  onClickAddGroup,
  onChangeAddGroupName,
  isNewGroupNameInvalid,
}) {
  return (
    <div id="inputgroups-new-group-item" data-testid="inputgroups-new-group-item" className="group-item">
      <div id="inputgroups-new-group-item-wrapped" data-testid="inputgroups-new-group-item-wrapper" className="w-75 flex">
        <input
          id="inputgroups-new-group-item-input"
          data-testid="inputgroups-new-group-item-input"
          type="text"
          className={isNewGroupNameInvalid ? 'invalid-new-name' : null}
          placeholder="Type New Group"
          value={text}
          onChange={onChangeAddGroupName}
        />
      </div>
      <div
        id="inputgroups-new-group-item-actions"
        data-testid="inputgroups-new-group-item-actions"
        className={`flex flex-space-between w-25  ${
          text !== '' && !isNewGroupNameInvalid
            ? 'group-update-active'
            : 'group-update-inactive'
        }`}
      >
        <RemoveGroup
          id="inputgroups-new-group-item-remove-group-svgs"
          data-testid="inputgroups-new-group-item-remove-group-svgs"
          className="edit-group-svgs"
          onClick={onClickRemoveAddGroup}
        />
        <AddGroup
          id="inputgroups-new-group-item-add-group-svgs"
          data-testid="inputgroups-new-group-item-add-group-svgs"
          className="edit-group-svgs"
          onClick={onClickAddGroup}
        />
      </div>
    </div>
  );
}
export function IngredientCard({
  customStyle,
  onEditIngredient = null,
  onDeleteIngredient,
  ingredientData,
  setContentView,
  setEditIngredientData,
  setSelectedIngredient,
  probability,
  showColor = true,
  isEditMode = true,
  disabled = false,
}: IngredientCardProps) {
  const isScreenEditable: boolean = useIsScreenIngredientEditable();
  const stockData = getIngredientStock(ingredientData.ingredientStockId);
  const highphStock = getIngredientStock(ingredientData.highPhingredientStockId);
  const ingColor = getIngredientColor(ingredientData.ingredientIngredientTypeId);
  function editLayerIngredients() {
    const ingName = getIngredientName(ingredientData.ingredientIngredientTypeId);
    setSelectedIngredient({
      id: ingredientData.ingredientIngredientTypeId,
      name: ingName,
    });
    setEditIngredientData(ingredientData);
    setContentView(ELayersView.EDITINGREDIENTSVIEW);
  }

  function getIngCustomPHView() {
    let phView = '';
    if (
      !isNullOrUndefined(ingredientData.startpH) ||
      !isNullOrUndefined(ingredientData.stoppH)
    ) {
      phView = `pH: ${ingredientData.startpH}-${
        ingredientData.stoppH
      } (Vary Along ${getVaryAlongName(ingredientData.pHvaryAlong)})`;
    } else if (!isNullOrUndefined(ingredientData.pH)) {
      phView = `pH: ${ingredientData.pH}`;
    } else if (
      !isNullOrUndefined(ingredientData.lowPh) ||
      !isNullOrUndefined(ingredientData.highPh)
    ) {
      phView = `pH: ${ingredientData.lowPh} - ${ingredientData.highPh}`;
    }
    return phView;
  }

  if (isNullOrUndefined(ingColor) || !stockData) {
    return null;
  }
  return (
    <div
      id="inputgroups-ingredient-card-probability"
      data-testid="inputgroups-ingredient-card-probability"
      className={probability ? 'no-border-ingredient-card' : 'ingredient-card'}
      style={customStyle}
    >
      <div
        id="inputgroups-ingredient-card-icon"
        data-testid="inputgroups-ingredient-card-icon"
        className="flex ing-icons  flex-space-between flex-y-center"
      >
        {showColor == true && (
          <div
            id="inputgroups-ingredient-card-icon-ing-color"
            data-testid="inputgroups-ingredient-card-icon-ing-color"
            style={{
              height: '40px',
              width: '8px',
              marginRight: '10px',
              background: `#${ingColor.toString(16).padStart(6, '0').toUpperCase()}`,
            }}
          ></div>
        )}
        <IngredientsRect />
      </div>
      <div
        id="inputgroups-ingredient-card-ing-content"
        data-testid="inputgroups-ingredient-card-ing-content"
        className="flex flex-column ing-content"
      >
        <div
          id="inputgroups-ingredient-card-text"
          data-testid="inputgroups-ingredient-card-text"
          className="ingredient-card-text"
        >
          {' '}
          {isNullOrUndefined(stockData)
            ? null
            : `${getIngredientTypeName(
                ingredientData.ingredientIngredientTypeId,
              )} - ${getIngNameByIngId(stockData.ingredientId)}`}
        </div>
        {isNullOrUndefined(probability) ? (
          <div
            id="inputgroups-ingredient-card-text-ingredient-data-empty-concentration"
            data-testid="inputgroups-ingredient-card-text-ingredient-data-empty-concentration"
            className="ingredient-card-text ing-card-light"
          >
            Conc:{' '}
            {isNullOrUndefined(ingredientData.startConcentration)
              ? isNullOrUndefined(ingredientData.concentration)
                ? 0
                : ingredientData.concentration
              : ingredientData.startConcentration}{' '}
            {ingredientData.concentrationVaryAlong !== EGridVaryAlong.NONE &&
            !isNullOrUndefined(ingredientData.concentrationVaryAlong)
              ? `- ${
                  !isNullOrUndefined(ingredientData.stopConcentration)
                    ? ingredientData.stopConcentration
                    : ''
                } (Vary Along ${getVaryAlongName(ingredientData.concentrationVaryAlong)})`
              : ''}
          </div>
        ) : (
          <div
            id="inputgroups-ingredient-card-text-ingredient-data-range-stock-concentration"
            data-testid="inputgroups-ingredient-card-text-ingredient-data-range-stock-concentration"
            className="ingredient-card-text ing-card-light"
          >
            Conc: {ingredientData.lowConcentration} - {ingredientData.highConcentration}{' '}
            {stockData.concentrationUnits}
          </div>
        )}
        {probability ? (
          <div
            id="inputgroups-ingredient-card-text-ingredient-data-weight-concentration"
            data-testid="inputgroups-ingredient-card-text-ingredient-data-weight-concentration"
            className="ingredient-card-text ing-card-light"
          >
            Weight: {ingredientData.weight} &emsp; Probability: {probability}
          </div>
        ) : null}
        {stockData.isBuffer ? (
          <>
            <div
              id="inputgroups-ingredient-card-text-ingredient-data-custom-ph"
              data-testid="inputgroups-ingredient-card-text-ingredient-data-custom-ph"
              className="ingredient-card-text ing-card-light"
            >
              {getIngCustomPHView()}
            </div>
            <div
              id="inputgroups-ingredient-card-text-ingredient-data-stock-ph-concentration"
              data-testid="inputgroups-ingredient-card-text-ingredient-data-stock-ph-concentration"
              className="ingredient-card-text ing-card-light"
            >
              {stockData.stockConcentration} {stockData.concentrationUnits}, pH{' '}
              {stockData.stockPh}{' '}
              {getIngIdStockNumber(stockData.ingredientId, stockData.stockNumber)}
            </div>
            {highphStock && (
              <div
                id="inputgroups-ingredient-card-text-ingredient-data-high-ph-concentration"
                data-testid="inputgroups-ingredient-card-text-ingredient-data-high-ph-concentration"
                className="ingredient-card-text ing-card-light"
              >
                {highphStock.stockConcentration} {highphStock.concentrationUnits}, pH{' '}
                {highphStock.stockPh}{' '}
                {getIngIdStockNumber(highphStock.ingredientId, highphStock.stockNumber)}
              </div>
            )}
          </>
        ) : (
          <div
            id="inputgroups-ingredient-card-text-ingredient-stock-number"
            data-testid="inputgroups-ingredient-card-text-ingredient-stock-number"
            className="ingredient-card-text ing-card-light"
          >
            {stockData.stockConcentration} {stockData.concentrationUnits}{' '}
            {getIngIdStockNumber(stockData.ingredientId, stockData.stockNumber)}{' '}
          </div>
        )}
      </div>
      {isEditMode && isScreenEditable && (
        <div
          id="inputgroups-ingredient-card-text-ingredient-edit-mode"
          data-testid="inputgroups-ingredient-card-text-ingredient-edit-mode"
          className={`flex flex-space-around px-2 w-[30%] ${
            disabled ? 'ing-delete-update-disabled' : '[&_path]:fill-black'
          }`}
        >
          <Edit
            id="inputgroups-ingredient-card-text-ingredient-edit-button"
            data-testid="inputgroups-ingredient-card-text-ingredient-edit-button"
            onClick={
              !disabled
                ? onEditIngredient
                  ? onEditIngredient
                  : editLayerIngredients
                : null
            }
            className={disabled ? 'cursor-disabled' : 'cursor-pointer hover:opacity-70'}
          />
          <Delete
            id="inputgroups-ingredient-card-text-ingredient-delete-button"
            data-testid="inputgroups-ingredient-card-text-ingredient-delete-button"
            onClick={!disabled ? onDeleteIngredient : null}
            className={disabled ? 'cursor-disabled' : 'cursor-pointer hover:opacity-70'}
          />
        </div>
      )}
    </div>
  );
}

export function ScreenCard({
  screenName,
  lotComments,
  conditions,
  usedConditions,
  customStyle,
  isEditMode = true,
  onEditScreen,
  onDeleteScreen,
}: ScreenCardProps) {
  return (
    <div
      id="inputgroups-screen-card"
      data-testid="inputgroups-screen-card"
      className={'ingredient-card'}
      style={customStyle}
    >
      <div
        id="inputgroups-screen-card-icons"
        data-testid="inputgroups-screen-card-icons"
        className="flex ing-icons  flex-space-between flex-y-center"
      >
        <ScreenRect />
      </div>
      <div
        id="inputgroups-screen-card-content"
        data-testid="inputgroups-screen-card-content"
        className="flex flex-column ing-content"
      >
        <div
          id={`inputgroups-screen-card-screen-${screenName}`}
          data-testid={`inputgroups-screen-card-screen-${screenName}`}
          className="ingredient-card-text"
        >
          {screenName}
        </div>
        <div
          id="inputgroups-screen-card-conditions"
          data-testid="inputgroups-screen-card-conditions"
          className="ingredient-card-text ing-card-light"
        >
          {lotComments + ', conditions ' + conditions + ', used ' + usedConditions}
        </div>
      </div>
      {isEditMode && (
        <div
          id="inputgroups-screen-card-edit-mode"
          data-testid="inputgroups-screen-card-edit-mode"
          className="flex ing-delete-update flex-space-around [&_path]:fill-black"
        >
          <Edit
            id="inputgroups-screen-card-edit-button"
            data-testid="inputgroups-screen-card-edit-button"
            onClick={onEditScreen}
            className="cursor-pointer hover:opacity-70"
          />
          <Delete
            id="inputgroups-screen-card-delete-button"
            data-testid="inputgroups-screen-card-delete-button"
            onClick={onDeleteScreen}
            className="cursor-pointer hover:opacity-70"
          />
        </div>
      )}
    </div>
  );
}

export function SeedCard({
  style,
  onEditSeed,
  onDeleteSeed,
  layerData,
  isEditMode = true,
  editSeedData,
  setContentView,
  setEditSeedData,
  setSelectedSeed,
}: SeedCardProps) {
  function GetSeedVolumes(layerData) {
    const seedLayerDetail: SeedLayerDetailsDTO = layerData.layerDetail;
    if (seedLayerDetail.seedDropVolumeVaryAlong === EGridVaryAlong.NONE) {
      return seedLayerDetail.startSeedDropVolume;
    } else {
      return (
        seedLayerDetail.startSeedDropVolume + ' - ' + seedLayerDetail.stopSeedDropVolume
      );
    }
  }

  return (
    <div id="inputgroups-seed-card" data-testid="inputgroups-seed-card" className="ingredient-card " style={style}>
      <div
        id="inputgroups-seed-card-icons"
        data-testid="inputgroups-seed-card-icons"
        className="flex ing-icons  flex-space-between flex-y-center"
      >
        <IngredientsRect />
      </div>
      <div
        id="inputgroups-seed-card-content"
        data-testid="inputgroups-seed-card-content"
        className="flex flex-column ing-content"
      >
        <div
          id="inputgroups-seed-card-seed-name"
          data-testid="inputgroups-seed-card-seed-name"
          className="ingredient-card-text"
        >
          {' '}
          {GetSeedName(layerData.layerDetail.seedId)}
        </div>
        <div
          id="inputgroups-seed-card-seed-volumes"
          data-testid="inputgroups-seed-card-seed-volumes"
          className="ingredient-card-text ing-card-light"
        >
          Drop {layerData.targetDrop}, Seed Vol {GetSeedVolumes(layerData)} µL
        </div>
      </div>

      {isEditMode && (
        <div
          id="inputgroups-seed-card-edit-mode"
          data-testid="inputgroups-seed-card-edit-mode"
          className="flex ing-delete-update flex-space-around [&_path]:fill-black"
        >
          <Edit
            id="inputgroups-seed-card-edit-button"
            data-testid="inputgroups-seed-card-edit-button"
            onClick={onEditSeed}
            className="cursor-pointer hover:opacity-70"
          />
          <Delete
            id="inputgroups-seed-card-delete-button"
            data-testid="inputgroups-seed-card-delete-button"
            onClick={onDeleteSeed}
            className="cursor-pointer hover:opacity-70"
          />
        </div>
      )}
    </div>
  );
}

export function ProteinCard({
  style,
  onEditProtein,
  onDeleteProtein,
  layerData,
  selectedPF,
  isEditMode = true,
}: ProteinCardProps) {
  function getProteinVolumes(proteinLayerProteinFormulation) {
    const plPF: ProteinLayerProteinFormulationDTO = proteinLayerProteinFormulation;
    if (plPF.proteinDropVolumeVaryAlong === EGridVaryAlong.NONE) {
      return plPF.startProteinDropVolume;
    } else {
      return plPF.startProteinDropVolume + ' - ' + plPF.stopProteinDropVolume;
    }
  }

  return (
    <div
      id="inputgroups-protein-card"
      data-testid="inputgroups-protein-card"
      className="ingredient-card "
      style={style}
    >
      <div
        id="inputgroups-protein-card-icons"
        data-testid="inputgroups-protein-card-icons"
        className="flex ing-icons  flex-space-between flex-y-center"
      >
        <IngredientsRect />
      </div>
      <div
        id="inputgroups-protein-card-content"
        data-testid="inputgroups-protein-card-content"
        className="flex flex-column ing-content"
      >
        <div
          id="inputgroups-protein-card-protein-formulation-name"
          data-testid="inputgroups-protein-card-protein-formulation-name"
          className="ingredient-card-text"
        >
          {' '}
          {GetProteinFormulationName(
            layerData.layerDetail.proteinLayerProteinFormulation[0].proteinFormulationId,
          )}
        </div>
        <div
          id="inputgroups-protein-card-protein-volumes"
          data-testid="inputgroups-protein-card-protein-volumes"
          className="ingredient-card-text ing-card-light"
        >
          Drop {layerData.targetDrop}, Protein Vol{' '}
          {getProteinVolumes(layerData.layerDetail.proteinLayerProteinFormulation[0])} µL
        </div>
      </div>
      {isEditMode && (
        <div
          id="inputgroups-protein-card-edit-mode"
          data-testid="inputgroups-protein-card-edit-mode"
          className="flex ing-delete-update flex-space-around [&_path]:fill-black"
        >
          <Edit
            id="inputgroups-protein-card-edit-button"
            data-testid="inputgroups-protein-card-edit-button"
            onClick={onEditProtein}
            className="cursor-pointer hover:opacity-70"
          />
          <Delete
            id="inputgroups-protein-card-delete-button"
            data-testid="inputgroups-protein-card-delete-button"
            onClick={onDeleteProtein}
            className="cursor-pointer hover:opacity-70"
          />
        </div>
      )}
    </div>
  );
}

export function RandomLayerIngredientCard({
  ing,
  probability,
  deleteIngredientInSelectedGroup,
  onClickEditIngredient,
}: RandomLayerGroupIngredientProps) {
  const stock = getIngredientStock(ing.ingredientStockId);
  return (
    <div>
      <div id="inputgroups-random-layer-ingredient-card" data-testid="inputgroups-random-layer-ingredient-card" className="groupDetail">
        <div
          id="inputgroups-random-layer-ingredient-card-wrapper"
          data-testid="inputgroups-random-layer-ingredient-card-wrapper"
          className="w-75 flex"
        >
          <div
            id="inputgroups-random-layer-ingredient-card-icons"
            data-testid="inputgroups-random-layer-ingredient-card-icons"
            className="flex ing-icons  flex-space-between flex-y-center"
          >
            <div
              id="inputgroups-random-layer-ingredient-card-ingredient-color"
              data-testid="inputgroups-random-layer-ingredient-card-ingredient-color"
              style={{
                height: '40px',
                width: '8px',
                background: `#${getIngredientColor(
                  ing.ingredientIngredientTypeId,
                ).toString(16)}`,
              }}
            ></div>
            <IngredientsRect />
          </div>
          <div
            id="inputgroups-random-layer-ingredient-card-content"
            data-testid="inputgroups-random-layer-ingredient-card-content"
            className="flex flex-column ing-content"
          >
            <div
              id="inputgroups-random-layer-ingredient-card-ingredient-name"
              data-testid="inputgroups-random-layer-ingredient-card-ingredient-name"
              className="ingredient-card-text"
            >
              {' '}
              {getIngredientTypeName(ing.ingredientIngredientTypeId)} -{' '}
              {getIngredientName(ing.ingredientIngredientTypeId)}
            </div>
            <div
              id="inputgroups-random-layer-ingredient-card-range-stock"
              data-testid="inputgroups-random-layer-ingredient-card-range-stock"
              className="ingredient-card-text ing-card-light"
            >
              Conc: {ing.lowConcentration} - {ing.highConcentration}{' '}
              {stock.concentrationUnits}
              {!isNullOrUndefined(ing.highPh)
                ? `, pH: ${ing.lowPh} - ${ing.highPh}`
                : null}
            </div>
            <div
              id="inputgroups-random-layer-ingredient-card-weight"
              data-testid="inputgroups-random-layer-ingredient-card-weight"
              className="ingredient-card-text ing-card-light"
            >
              Weight: {ing.weight} &nbsp; Probability: {probability}
            </div>
            <div
              id="inputgroups-random-layer-ingredient-card-stock-number"
              data-testid="inputgroups-random-layer-ingredient-card-stock-number"
              className="ingredient-card-text ing-card-light"
            >
              Stock: {stock.stockConcentration} {stock.concentrationUnits}
              {!isNullOrUndefined(ing.highPh) ? `, pH: ${stock.stockPh}` : null} (
              {stock.ingredientId}-{stock.stockNumber})
            </div>
          </div>
        </div>
        <div
          id="inputgroups-random-layer-ingredient-card-edit-mode"
          data-testid="inputgroups-random-layer-ingredient-card-edit-mode"
          className="flex ing-delete-update-enabled flex-space-around w-25"
        >
          <Edit
            id="inputgroups-random-layer-ingredient-card-edit-button"
            data-testid="inputgroups-random-layer-ingredient-card-edit-button"
            onClick={() => onClickEditIngredient(ing)}
          />
          <Delete
            id="inputgroups-random-layer-ingredient-card-delete-button"
            data-testid="inputgroups-random-layer-ingredient-card-delete-button"
            onClick={(e) => deleteIngredientInSelectedGroup(ing)}
          />
        </div>
      </div>
    </div>
  );
}

export function RandomLayerExcludeIngredientCard({ ing }) {
  const ings = GetIngredients();
  if (isNullOrUndefined(ings)) {
    return <></>;
  }
  const i = ings.ingredientIngredientType.find((i) => i.ingredientId === ing.id);
  return (
    <div>
      <div
        id="inputgroups-random-layer-exclude-ingredient-card"
        data-testid="inputgroups-random-layer-exclude-ingredient-card"
        className="groupDetail"
      >
        <div
          id="inputgroups-random-layer-exclude-ingredient-card-wrapped"
          data-testid="inputgroups-random-layer-exclude-ingredient-card-wrapped"
          className="w-75 flex"
        >
          <div
            id="inputgroups-random-layer-exclude-ingredient-card-icons"
            data-testid="inputgroups-random-layer-exclude-ingredient-card-icons"
            className="flex ing-icons  flex-space-between flex-y-center"
          >
            <div
              id="inputgroups-random-layer-exclude-ingredient-card-ingredient-color"
              data-testid="inputgroups-random-layer-exclude-ingredient-card-ingredient-color"
              style={{
                height: '25px',
                width: '8px',
                background: getIngredientColor(i.id),
                marginRight: 5,
              }}
            ></div>
            <IngredientsRect />
          </div>
          <div
            id="inputgroups-random-layer-exclude-ingredient-card-content"
            data-testid="inputgroups-random-layer-exclude-ingredient-card-content"
            className="flex flex-column ing-content"
          >
            <div
              id="inputgroups-random-layer-exclude-ingredient-card-ingredient-name-by-ingredient-id"
              data-testid="inputgroups-random-layer-exclude-ingredient-card-ingredient-name-by-ingredient-id"
              className="ingredient-card-text"
            >
              {' '}
              {getIngNameByIngId(i.ingredientId)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export function StocksCard({
  stockData,
  isFavourite,
  onClick,
  setGlobalFavIngStocks,
}: StockCardProps) {
  return (
    <div id="inputgroups-stocks-card" data-testid="inputgroups-stocks-card" className="stock-card" onClick={onClick}>
      <div
        id="inputgroups-stocks-card-stock-conc-vendor"
        data-testid="inputgroups-stocks-card-stock-conc-vendor"
        className="stock-top-left"
      >
        {getStockConcVendor(stockData, false)}
      </div>
      {stockData.isBuffer && (
        <div
          id="inputgroups-stocks-card-stock-data-ph"
          data-testid="inputgroups-stocks-card-stock-data-ph"
          className="stock-top-right-ph"
        >
          pH {stockData.stockPh}
        </div>
      )}
      <div
        id="inputgroups-stocks-car-ingredient-id-stock-number "
        data-testid="inputgroups-stocks-car-ingredient-id-stock-number"
        className="stock-bottom-left"
      >
        {getIngIdStockNumber(stockData.ingredientId, stockData.stockNumber)}
      </div>
      <div
        id="inputgroups-stocks-card-vendor-part-number"
        data-testid="inputgroups-stocks-card-vendor-part-number"
        className="stock-bottom-right"
      >
        {stockData.vendorPartNumber}
      </div>
      {
        <div
          id="inputgroups-stocks-card-update-favorite-stock"
          data-testid="inputgroups-stocks-card-update-favorite-stock"
          className="stock-top-right"
          onClick={(e) =>
            updateFavouriteStock(e, stockData, isFavourite, setGlobalFavIngStocks)
          }
        >
          <RMSvgIcon
            id="inputgroups-stocks-card-favorite-icon"
            data-testid="inputgroups-stocks-card-favorite-icon"
            name="Favourite"
            fill={`${isFavourite ? '#FFCA0A' : '#D3D3D3'}`}
          />
        </div>
      }
    </div>
  );
}

export const RMMultipleRadioButtons = ({ options, name, selectedValue, onChange }) => {
  return (
    <div id="inputgroups-rm-multiple-radio-buttons" data-testid="inputgroups-rm-multiple-radio-buttons">
      {options.map((option, index) => (
        <label
          id={`inputgroups-rm-multiple-radio-buttons-label-${index}`}
          data-testid={`inputgroups-rm-multiple-radio-buttons-label-${index}`}
          key={index}
          style={{ marginRight: '10px' }}
        >
          <input
            id="inputgroups-rm-multiple-radio-buttons-input"
            data-testid={`inputgroups-rm-multiple-radio-buttons-input-${index}`}
            type="radio"
            name={name}
            value={option.value}
            checked={selectedValue === option.value}
            onChange={() => onChange(option.value)}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
};

export const RMRadioButton = ({
  selected,
  onClick,
  value,
  label,
  disabled = false,
  styleLabel = {},
  styleCircle = {},
  style = {},
}) => {
  return (
    <label
      id={`inputgroups-rm-radio-buttons-label-${label}`}
      data-testid={`inputgroups-rm-radio-buttons-label-${label}`}
      style={{ display: 'flex', alignItems: 'center', ...styleLabel }}
    >
      <input
        id="inputgroups-rm-radio-buttons-input"
        data-testid="inputgroups-rm-radio-buttons-input"
        type="radio"
        checked={selected == value}
        onChange={onClick}
        value={value}
        disabled={disabled}
        style={{
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          border: '2px solid #000',
          marginRight: '5px',
          position: 'relative',
          cursor: 'pointer',
          outline: 'none',
          transition: 'all 0.3s ease',
          ...styleCircle, // Apply custom styles for the circle
        }}
      />
      <span
        id="inputgroups-rm-radio-buttons-style-label"
        data-testid="inputgroups-rm-radio-buttons-style-label"
        style={{ fontSize: '16px', marginLeft: '2%', ...styleLabel }}
      >
        {label}
      </span>
    </label>
  );
};

const updateFavouriteStock = async (
  e,
  stockData: IngredientStockDTO,
  isFavourite,
  setGlobalFavIngStocks,
) => {
  e.preventDefault();
  e.stopPropagation();
  const ingType = GetIngredients().ingredientIngredientType.find(
    (ingIngType) => ingIngType.ingredientId === stockData.ingredientId,
  );
  const favIngredientDTO: FavouriteIngredientStockDTO = new FavouriteIngredientStockDTO();
  favIngredientDTO.ingredientStockId = stockData.id;
  favIngredientDTO.ingredientIngredientTypeId = ingType.id;
  favIngredientDTO.isFavourite = isFavourite;
  const response = await updateFavouriteIngStock(favIngredientDTO);
  SetFavouriteStocks(response);
  setGlobalFavIngStocks(response);
  showSnackBar('Favourite ingredient stock updated');
};

type RMOKButtonProps = {
  onClick: (e: any) => void;
  text: string;
  disabled?: boolean;
  background?: string;
};
export const RMOKButton = ({
  onClick,
  text,
  disabled = false,
  background = '#F89723',
}: RMOKButtonProps) => {
  return (
    <FmlxButton
      id="inputgroup-rmokbutton-wrapper"
      data-testid="inputgroup-rmokbutton-wrapper"
      type={FmlxButton.Type.BASIC}
      style={{
        color: 'white',
        backgroundColor: background,
        display: 'inline-block',
        border: 'none',
        margin: '0px',
        width: 150,
        height: 44,
        borderRadius: 4,
        fontSize: 18,
        lineHeight: '21px',
        fontStyle: 'normal',
        fontWeight: 'normal',
      }}
      onClick={onClick}
      label={text}
      disabled={disabled}
    />
  );
};
